/**
 * Judge.me reviews — Embla-powered carousel.
 * Groups .jdgm-rev into slides (2 per page desktop, 1 mobile).
 * Auto-loads all Judge.me pages in background, then syncs once.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 768px)';
  var HIDE_CLS = 'af-vk-rev-pending';

  function pageSize() {
    return window.matchMedia(DESKTOP_MQ).matches ? 2 : 1;
  }

  function getRevs(host) {
    if (!host) return [];
    return Array.prototype.slice.call(host.querySelectorAll('.jdgm-rev'));
  }

  function init(root) {
    if (!root || root.getAttribute('data-af-vk-recenze-init') === '1') return;
    root.setAttribute('data-af-vk-recenze-init', '1');

    var Embla = window.EmblaCarousel;
    if (!Embla) return;

    var panel = root.closest('[data-af-vk-swap-panel]');
    var nav = root.querySelector('[data-af-vk-recenze-nav]');
    var prevBtn = root.querySelector('[data-af-vk-recenze-prev]');
    var nextBtn = root.querySelector('[data-af-vk-recenze-next]');
    var emblaInstance = null;
    var building = false;
    var layoutTimer;
    var prevPageSize = pageSize();
    var needsSync = false;

    /** Native `hidden` is overridden by `.tw-flex { display:flex !important }` — keep `tw-hidden` in sync. */
    function setRecenzeNavConcealed(conceal) {
      if (!nav) return;
      nav.hidden = conceal;
      nav.classList.toggle('tw-hidden', conceal);
    }

    function wrapEl() {
      return root.querySelector('.af-vk-recenze-jdgm__widget-wrap');
    }

    function destroyEmbla() {
      if (emblaInstance) {
        emblaInstance.destroy();
        emblaInstance = null;
      }
    }

    function destroySlider(host) {
      destroyEmbla();
      var vp = host.querySelector('[data-af-vk-recenze-viewport]');
      if (!vp) return;
      var parent = vp.parentNode;
      Array.prototype.slice.call(vp.querySelectorAll('.jdgm-rev')).forEach(function (r) {
        parent.insertBefore(r, vp);
      });
      vp.remove();
    }

    function setHeight(vp, h, animate) {
      if (!vp || h <= 0) return;
      if (Math.abs(vp.offsetHeight - h) < 1) return;
      if (!animate) {
        vp.style.transition = 'none';
        vp.style.height = h + 'px';
        vp.offsetHeight;
        vp.style.transition = 'height 0.25s ease-out';
      } else {
        vp.style.height = h + 'px';
      }
    }

    function selectedSlideHeight(vp) {
      if (!vp || !emblaInstance) return 0;
      var slides = vp.querySelectorAll('.af-vk-recenze-page');
      var idx = emblaInstance.selectedScrollSnap();
      return slides[idx] ? slides[idx].offsetHeight : 0;
    }

    function makeSlide(revBatch, ps) {
      var slide = document.createElement('div');
      slide.className = 'af-vk-recenze-page embla__slide';
      slide.style.cssText = 'flex:0 0 100%;min-width:0;display:flex;flex-direction:column;gap:16px';
      for (var i = 0; i < ps && i < revBatch.length; i++) {
        revBatch[i].classList.remove(HIDE_CLS);
        revBatch[i].style.marginTop = '0';
        slide.appendChild(revBatch[i]);
      }
      return slide;
    }

    function appendToSlider(vp, loose, ps) {
      var track = vp.querySelector('.af-vk-recenze-track');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.af-vk-recenze-page'));
      var last = slides.length ? slides[slides.length - 1] : null;
      var room = last ? ps - last.querySelectorAll('.jdgm-rev').length : 0;
      var i = 0;

      while (i < loose.length && room > 0) {
        loose[i].classList.remove(HIDE_CLS);
        loose[i].style.marginTop = '0';
        last.appendChild(loose[i]);
        i++;
        room--;
      }

      while (i < loose.length) {
        var batch = loose.slice(i, i + ps);
        track.appendChild(makeSlide(batch, ps));
        i += ps;
      }

      needsSync = true;
      syncEmbla();
    }

    function syncEmbla() {
      if (!needsSync || !emblaInstance) return;
      needsSync = false;
      emblaInstance.reInit();
    }

    function buildSlider(host, revs) {
      if (!revs.length) return null;
      var ref = revs[0];
      var parent = ref.parentNode;
      if (!parent) return null;

      var ps = pageSize();

      var vp = document.createElement('div');
      vp.setAttribute('data-af-vk-recenze-viewport', '');
      vp.className = 'af-vk-recenze-viewport embla__viewport';
      vp.style.transition = 'height 0.25s ease-out';

      var track = document.createElement('div');
      track.className = 'af-vk-recenze-track embla__container';
      track.style.cssText = 'display:flex;align-items:flex-start';

      parent.insertBefore(vp, ref);

      var slideCount = Math.ceil(revs.length / ps);
      for (var p = 0; p < slideCount; p++) {
        var batch = revs.slice(p * ps, (p + 1) * ps);
        track.appendChild(makeSlide(batch, ps));
      }
      vp.appendChild(track);

      emblaInstance = Embla(vp, {
        loop: false,
        align: 'start',
        containScroll: 'keepSnaps',
        dragFree: false,
        slidesToScroll: 1,
        watchDrag: true
      });

      function updateNav() {
        if (!emblaInstance) return;
        var canPrev = emblaInstance.canScrollPrev();
        var canNext = emblaInstance.canScrollNext();
        setRecenzeNavConcealed(!canPrev && !canNext);
        if (prevBtn) prevBtn.disabled = !canPrev;
        if (nextBtn) nextBtn.disabled = !canNext;
      }

      emblaInstance.on('select', function () {
        updateNav();
        var targetH = selectedSlideHeight(vp);
        if (targetH > vp.offsetHeight) {
          setHeight(vp, targetH, true);
        }
      });

      emblaInstance.on('settle', function () {
        setHeight(vp, selectedSlideHeight(vp), true);
      });

      emblaInstance.on('reInit', function () {
        updateNav();
        setHeight(vp, selectedSlideHeight(vp), false);
      });

      updateNav();
      setHeight(vp, selectedSlideHeight(vp), false);
      needsSync = false;

      return vp;
    }

    function layout() {
      if (building) return;
      if (panel && panel.hidden) return;
      building = true;
      try {
        var w = wrapEl();
        if (!w) return;

        var emptyEl = root.querySelector('[data-af-vk-recenze-empty]');
        var total = getRevs(w).length;
        var ps = pageSize();

        if (total === 0) {
          destroySlider(w);
          setRecenzeNavConcealed(true);
          if (emptyEl) emptyEl.hidden = false;
          return;
        }

        if (emptyEl) emptyEl.hidden = true;

        var vp = w.querySelector('[data-af-vk-recenze-viewport]');
        var looseRevs = getRevs(w).filter(function (r) {
          return !r.closest('[data-af-vk-recenze-viewport]');
        });

        if (!vp || ps !== prevPageSize) {
          destroySlider(w);
          buildSlider(w, getRevs(w));
        } else if (looseRevs.length > 0) {
          appendToSlider(vp, looseRevs, ps);
        }

        prevPageSize = ps;
      } finally {
        building = false;
      }
    }

    function scheduleLayout() {
      clearTimeout(layoutTimer);
      layoutTimer = setTimeout(layout, 120);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      syncEmbla();
      if (emblaInstance) emblaInstance.scrollPrev();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      syncEmbla();
      if (emblaInstance) emblaInstance.scrollNext();
    });

    function autoLoadMore() {
      var w = wrapEl();
      if (!w) return;
      var btn =
        w.querySelector('.jdgm-paginate__load-more:not(.disabled):not([disabled])') ||
        w.querySelector('.jdgm-paginate .jdgm-paginate__load-more');
      if (btn && !btn.classList.contains('disabled') && !btn.hasAttribute('disabled')) {
        btn.click();
        setTimeout(autoLoadMore, 2000);
      } else {
        syncEmbla();
      }
    }

    var w = wrapEl();
    if (w) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && n.classList && n.classList.contains('jdgm-rev')) {
              if (!n.closest('[data-af-vk-recenze-viewport]')) {
                n.classList.add(HIDE_CLS);
              }
            }
          }
        }
        if (!building) scheduleLayout();
      }).observe(w, { childList: true, subtree: true });
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) scheduleLayout(); });
    }, { threshold: 0.01 }).observe(root);

    if (panel) {
      new MutationObserver(function () {
        if (!panel.hidden) {
          clearTimeout(layoutTimer);
          layout();
        }
      }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (pageSize() !== prevPageSize) scheduleLayout();
      }, 120);
    });

    scheduleLayout();
    setTimeout(autoLoadMore, 1500);
  }

  function scan() {
    document.querySelectorAll('[data-af-vk-recenze-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
